import { render, staticRenderFns } from "./itemDoc.vue?vue&type=template&id=7f396ac4&"
import script from "./itemDoc.vue?vue&type=script&lang=js&"
export * from "./itemDoc.vue?vue&type=script&lang=js&"
import style0 from "./itemDoc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports